import React, { useState } from 'react';
import { Link } from 'gatsby';
import Card from './Card';

const ProjectCard = ({ project: { name, link, asset, thumbnail, description } }) => {
  const [imgSrc, setImgSrc] = useState(thumbnail);

  const setThumbnailSrc = () => setImgSrc(thumbnail);
  const setAssetSrc = () => setImgSrc(asset);

  return (
    <Link to={link}>
      <Card padding="p-0" className="mb-8">
        <img
          className="w-full h-full opacity-75 hover:opacity-100 transition duration-300"
          src={imgSrc}
          alt={name}
          onMouseOver={setAssetSrc}
          onFocus={setAssetSrc}
          onMouseOut={setThumbnailSrc}
          onBlur={setThumbnailSrc}
        />
        {/* <p className="text-xl font-semibold">{name}</p>
    <p className="mt-6">{description}</p>
    <div className="flex items-center mt-8">
    <div>
    <p>{link}</p>
        <p className="text-sm text-gray-600">{name}</p>
        </div>
      </div> */}
      </Card>
    </Link>
  );
};
export default ProjectCard;
